import React from 'react';

// Redux
import { useSelector } from 'react-redux';

// Components
import TitleComponent from '../TitleComponent';

const PaymentResumeModalComponent = ({ show, handleClose }) => {

    const paymentStore = useSelector((state) => state.payment);

    return (
        <div className={`modal ${show ? 'd-block' : 'd-none'}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header text-center">

                        <h5 className="modal-title text-center">Resumo do Pagamento</h5>
                        <button type="button" className="btn-close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="container d-flex flex-column align-items-center text-center">
                            <img src={`${process.env.PUBLIC_URL}/assets/confirm.gif`} style={{ height: '5rem' }} alt='Confirmado' />
                            <TitleComponent title={"Parabéns!"} />
                            <TitleComponent title={`Pagamento da ordem de serviço ${paymentStore.os_number} realizado com sucesso!`} />
                            <TitleComponent title={"Demais detalhes sobre o seu atendimento serão enviados para o e-mail cadastrado na solicitação."} />    
                        </div>
                    </div>
                    <div className="modal-footer" style={{ justifyContent: 'center' }}>
                        <button type="button" className="btn btn-success" onClick={handleClose}>Fechar</button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentResumeModalComponent;
